const DeleteFavouriteLockerIcon = ({ width = "20px", height = "20px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    width={width}
    height={height}
  >
    <g fill="#BC003B">
      <path d="M10 1.25A8.696 8.696 0 0 0 1.25 10 8.696 8.696 0 0 0 10 18.75 8.696 8.696 0 0 0 18.75 10 8.696 8.696 0 0 0 10 1.25Zm0 16.25c-4.125 0-7.5-3.375-7.5-7.5S5.875 2.5 10 2.5s7.5 3.375 7.5 7.5-3.375 7.5-7.5 7.5Z" />
      <path d="M13.375 14.375 10 11l-3.375 3.375-1-1L9 10 5.625 6.625l1-1L10 9l3.375-3.375 1 1L11 10l3.375 3.375-1 1Z" />
    </g>
  </svg>
);

export default DeleteFavouriteLockerIcon;
